export const MalayTranslationEnum = {
    StartScreen: {
        h1: "Terima kasih kerana memulakan perniagaan anda dengan kami!",
        p1: "Anda sedang memohon untuk",
        yellowContent: "Permohonan ini mesti dilengkapkan oleh pemilik, pengarah atau rakan kongsi seperti yang didaftarkan dalam SSM. Proses ini akan mengambil masa kurang daripada 15 minit.",
        p2: "Sebelum anda teruskan, sila pastikan semua pemohon memenuhi kriteria berikut:",
        pb1: "Kriteria Kelayakan",
        li1_1: "Perniagaan teras anda", 
        li1_2: "mematuhi Syariah",
        li1_3: "Jika tidak, sila ",
        li1_4: "memohon akaun yang lain",
        li2: "Perniagaan mesti didaftar sebagai milikan tunggal atau entiti sehingga 2 rakan kongsi/pengarah",
        li3: "Semua pemohon mestilah warganegara Malaysia dan pemegang Mykad terkini (dengan dwi imej/ versi 80k)",
        pb2: "Maklumat sokongan untuk pengesahan",
        li4: "Nombor Pendaftaran Perniagaan SSM",
        li5: "Imej tandatangan anda",
        li6: "Laporan SSM dikemas kini dengan senarai pemilik, rakan kongsi, pengarah/pemegang saham terkini",
        p3_1: "Jika anda tidak dapat memenuhi mana-mana syarat seperti yang tertera di atas, sila",
        p3_2: "jadualkan janji temu",
        p3_3: "dengan kami.",
        faq: {
            part1: "Klik",
            part2: "di sini",
            part3: "untuk soalan-soalan lazim."
        },
        b1: "Mula"
    },
    AppointmentScreen: {
        h1: "Sila beritahu kami maklumat hubungan anda",
        p1: "Sila berikan butiran anda untuk kami mengatur janji temu dengan anda.",
        label1: "Nama syarikat anda",
        label2: "Nombor pendaftaran perniagaan",
        label3: "Lokasi perniagaan",
        label4: "Cawangan OCBC pilihan",
        label5: "Nama anda",
        label6: "Nombor telefon bimbit anda",
        label7: "Alamat e-mel anda",
        b1: "Seterusnya",
        h2: "Terima kasih di atas minat anda dengan",
        p2: "Kami akan menghubungi anda dalam hari bekerja berikutnya untuk mendapatkan maklumat lanjut.",
        pleaseSelect: "Sila pilih"
    },
    TellUsScreen: {
        h1_1: "Bagaimanakah kami boleh menghubungi anda?",
        h1_2: "Sila isikan maklumat anda",
        label1: "Nama anda",
        label2: "Nombor telefon bimbit anda",
        label3: "Alamat e-mel anda",
        p1: "Sila pastikan butiran yang anda berikan adalah tepat.",
        p2: "Kami akan menggunakan maklumat perhubungan ini untuk menyimpan dan mendapatkan semula permohonan anda.",
        c1: "Saya bersetuju bahawa OCBC Bank akan menghantar SMS dan e-mel (yang mungkin mengandungi pautan boleh klik) mengenai permohonan ini dan/atau akaun kepada orang di atas",
        b1: "Seterusnya",
        pleaseSelect: "Sila pilih",
        numberError: {
            required: "Sila masukkan nombor telefon bimbit anda",
            minlength1: "Sila masukkan sekurang-kurangnya ",
            minlength2: " aksara",
            pattern: "Sila masukkan format yang sah"
        },
        emailError: {
            required: "Sila masukkan alamat e-mel anda",
            pattern: "Sila masukkan alamat e-mel yang sah"
        },
        p1c: "Untuk meneruskan permohonan, sila sahkan kod di bawah.",
        noteTitle: "Nota",
        note2: "Nombor telefon bimbit dan alamat e-mel yang diberi akan digunakan oleh OCBC Bank untuk tujuan perhubungan / komunikasi berkaitan kesemua akaun syarikat / perniagaan / persendirian dengan OCBC Bank. Untuk mengemas kini / menukar maklumat perhubungan, sila kunjungi kami di mana-mana cawangan OCBC untuk bantuan.",
        note1: "Sila masukkan aksara yang tertera di dalam imej",
        p2c: "Resend code",
        link1: "Dapatkan kod baharu",
        modal: {
            h1: "Adakah anda menerima SMS yang kami hantar?",
            p1 : {
                part1: "Anda akan terima SMS di",
                part2: "dalam 20 saat.",
                part3: "Pastikan telefon bimbit anda dihidupkan."
            },
            p2: "Jika anda tidak menerima SMS, sila kembali ke skrin sebelumnya dan semak bahawa anda telah mengisi nombor telefon bimbit yang betul.",
            b1: "Tidak",
            b2: "Ya",
        }
    },
    IdentifyYourCompanyScreen: {
        h1: "Sila kenal pasti syarikat anda",
        label1: "Apakah jenis perniagaan anda?",
        label2: "Pemilikan Tunggal/ Perkongsian",
        label3: "Sdn Bhd",
        label4: "Nombor Pendaftaran Perniagaan Baru",
        b1: "Cari",
        popup: "12 digit Nombor Pendaftaran SSM cth. 202101123456",
        error: "Nombor Pendaftaran Perniagaan Baru mestilah 12 digit.",
        noteBox: {
            part1: `Saya nyatakan dan memberi jaminan kepada OCBC Bank (Malaysia) Berhad dan OCBC Al-Amin Bank Berhad (secara kolektif, "Bank") bahawa saya diberi kuasa secara sah oleh entiti yang bernombor pendaftaran di atas ("Pemohon") dan pegawai-pegawainya, dan saya akan mengklik butang 'Carian' di bawah untuk Pihak Bank menjalankan carian terhadap Pemohon dan pegawai-pegawainya berdasarkan`,
            part2: "representasi dan jaminan",
            part3: "saya yang telah saya baca dan mengesahkan bahawa saya membuat jaminan yang sama."
        },
        errorLink: "Sila baca dan fahami pautan tersebut"
    },
    OTPScreen: {
        h1: "Sahkan maklumat perhubungan anda",
        h1_2: "Dapatkan semula permohonan anda yang disimpan",        
        p1: "Untuk meneruskan permohonan, sila sahkan kod di bawah.",
        note1: "Sila masukkan aksara yang tertera di dalam imej",
        p2: "Resend code",
        link1: "Dapatkan kod baharu ",
        seconds: "seconds",
        b1: "Seterusnya",
        modalError: "Anda tidak mempunyai percubaan lagi. Anda akan diarahkan ke skrin permulaan",
        modalError2: "Anda telah melebihi percubaan maksima untuk meminta SMS OTP, sila cuba sebentar lag.",
        otpError: "Sila masukkan OTP",
        otpError2: "OTP mesti dalam format nombor sahaja"
    },
    PasscodeScreen: {
        h1: "Dapatkan semula permohonan anda.",
        p1: "Masukkan kod laluan berdasarkan panduan yang kami hantar melalui e-mel.",
        l1: "Kod laluan",
        b1: "Seterusnya",
        passCodeError1: 'Kod laluan tidak sah. Sila cuba lagi.',
        passCodeError2: {
            part1: 'Tinggal ',
            part2: ' percubaan. Sila cuba lagi.'
        },
        passCodeError3: 'Anda telah mencapai percubaan maksimum. Sila hantar semula permohonan melalui e-mel yang kami hantar.'
    },
    ConfirmYourCompanyScreen: {
        h1: "Adakah ini syarikat anda?",
        b1: "Tidak",
        b2: "Ya",
    },
    CompanyDetailsInfoScreen: {
        h1: "Sila semak semua butiran syarikat anda",
        label1: "Nama perniagaan dan Nombor Pendaftaran Perniagaan",
        label2: "Jenis entiti",
        label3: "Alamat perniagaan",
        label4: "Jenis perniagaan",
        label5: "Pemilik/Rakan kongsi",
        label6: "Pengarah",
        label7: "Nama",
        label8: "Nombor kad pengenalan",
        label9: "Old Identification Number",
        b1: "Betul",
        b2: "Salah",
        modal: {
            h1: "Harap maaf, perniagaan anda tidak layak untuk Akaun OCBC eBiz-i",
            p1: "Adakah anda berminat untuk memohon Akaun OCBC eBiz?",
            p2: "Mengapa anda akan menyukai akaun ini",
            l1: "100% proses permohonan dalam talian",
            l2: "Deposit permulaan rendah RM500",
            l3: "Dilengkapi dengan set alat kewangan",
            p3: "Siapa yang boleh memohon",
            l4: "Perniagaan yang berdaftar dengan Suruhanjaya Syarikat Malaysia (SSM) - termasuk SME yang ditakrifkan oleh SME Corporation Malaysia",
            l5: "Perniagaan yang dimiliki oleh rakyat Malaysia sahaja",
            b1: "Ya",
            b2: "Tidak"
        }
    },
    CompanyNotFoundScreen: {
        p1: "Kami tidak menemui mana-mana syarikat aktif yang sepadan dengan entri anda.",
        p2_1: "Sila",
        p2_2: "cari semula",
        p2_3: "dengan menggunakan Jenis Perniagaan dan nombor Pendaftaran Perniagaan anda.",
        p3: "Tidak dapat mencari syarikat anda?",
        p4_1: "Hantarkan maklumat perhubungan anda",
        p4_2: "untuk kami atur janji temu.",
    },
    InforUpdateRecordScreen: {
        h1: "Harap maaf, anda perlu mengemas kini rekod SSM anda terlebih dahulu.",
        p1: {
            part1: "Rekod SSM yang tepat diperlukan untuk membuka akaun perniagaan dengan kami.", 
            part2:"Anda boleh mengemas kini rekod anda di",
            part3: "www.ssm.com.my"
        },
        p2: "Sila ambil perhatian bahawa kemas kini dengan SSM akan mengambil masa selama 2 hari.",
        p3: "Jika anda telah berjaya mengemaskinikan maklumat SSM anda, sila hantar semula permohonan.",
        p4: {
            part1: "Atau atur untuk",
            part2: "panggilan balik."
        }
    },
    BusinessDetailsScreen: {
        h1: "Butiran Perniagaan",
        label1: "Alamat surat-menyurat",
        edit: "Edit",
        ph1: "Nombor rumah/unit/tingkat atau nama bangunan",
        ph2: "Jalan atau daerah",
        ph3: "Bandar",
        label2: "Poskod",
        label3: "Negeri",
        label4: "Negara",
        label5: "Individu hubungan utama",
        label2Error:"Poskod tidak sah",
        b1: "Seterusnya",
        pleaseSelect: "Sila pilih",
        tooltip: "Anda diberi kuasa untuk menerima maklumat (termasuk kit permulaan Velocity@ocbc) dan menyampaikan maklumat kepada Bank. Maklumat perhubungan anda juga akan dicetak di bahagian Hubungan dalam Penyata Kiriman Wang yang dihantar kepada benefisiari anda. Notifikasi akaun anda untuk semua akaun peribadi anda dengan OCBC Bank akan dihantar ke nombor telefon bimbit dan alamat emel di atas"
    },
    AboutYourBusinessScreen: {
        h1: "Tentang perniagaan anda",
        label1: "Sila sahkan aktiviti utama anda:",
        label2: "Sila beritahu kami lebih lanjut tentang perniagaan anda:",
        ph1: "Contohnya: produk yang anda tawarkan, lokasi pelanggan dan pembekal",
        label3: "Sila nyatakan kategori industri anda:",
        ck1: "Pembuatan",
        ck2: "Perkhidmatan dan sektor-sektor lain",
        label4: "Berapakah bilangan pekerja tetap perniagaan anda?",
        label5: "Adakah perniagaan anda berurusan dalam mana-mana aktiviti berikut?",
        label6: "Sektor manakah yang paling sepadan dengan perniagaan anda?",
        label7: "Aktiviti utama anda:",
        li1: "Industri  berkaitan dengan persenjataan atau senjata",
        li2: "Kasino, hiburan, pertaruhan atau perniagaan lain yang berkaitan dengan perjudian",
        li3: "Perniagaan perkhidmatan wang",
        li4: " Mata wang maya",
        li5: "Pedagang Forex, pemasaran berbilang aras/skim piramid, penasihat pelaburan/perniagaan",
        li6_1: "Perniagaan yang",
        li6_2: "tidak patuh Syariah",
        li6_3: "",
        ck3: "Tidak, tiada yang di atas",
        ck4: "Ya, beberapa jenis aktiviti di atas",
        b1: "",
        b2: "Seterusnya",
        pleaseSelect: "Sila pilih"
    },
    AboutYourBusinessInfoScreen: {
        h1: "Tentang perniagaan anda",
        label1: "Di manakah perniagaan anda beroperasi terutamanya?",
        label2: "Dari manakah asal sumber dana awal untuk akaun ini?",
        ck1: "Hasil perniagaan ",
        ck2: "Pendapatan daripada pekerjaan ",
        ck3: "Hasil daripada pelaburan ",
        ck4: "Lain-lain",
        p1: "Sila jelaskan:",
        label3: "Perolehan perniagaan tahunan (RM)",
        label4: "Majoriti jualan anda berasal dari: ",
        label5: "Adakah anda pemilik utama dan pembuat keputusan tunggal syarikat?",
        ck5: "Ya",
        ck6: "Tidak",
        b1: "Simpan",
        b2: "Seterusnya",
        pleaseSelect: "Sila pilih",
        fundListError: "Sila pilih sumber pembiayaan",
        turnOverError: "Sila masukkan Perolehan perniagaan tahunan",
        ownerListError: "Sila pilih pemilik utama"
    },
    TaxStatusInfoScreen: {
        h1: "Status Cukai",
        label1: "Di manakah perniagaan anda membayar cukai?",
        ck1: "Malaysia",
        ck2: "Amerika Syarikat",
        label2: "Apakah nombor pengenalan cukai perniagaan ('Tax identification Number' - TIN) anda",
        ck3: "Lain-lain",
        label3: "Negara",
        label4: "Pernyataan manakah yang paling sesuai untuk menggambarkan perniagaan anda? ",
        label5: "Perniagaan saya adalah perniagaan yang aktif",
        label7: "Butiran Pendaftaran Cukai",
        p4: "TIN",
        p5: "SST",
        p3: "Selaras dengan inisiatif e-invois yang diperkenalkan oleh Lembaga Hasil Dalam Negeri Malaysia (LHDNM), semua pengguna akaun perniagaan sedia ada dan baru dikehendaki untuk memberikan Nombor Pengenalan Cukai (TIN) dan Nombor Pendaftaran Cukai Jualan dan Perkhidmatan (SST) Malaysia entiti mereka.",
        p1: "Menjana 50% atau lebih hasil perniagaannya daripada operasi perniagaan (Contohnya, Perdagangan Borong, Makanan dan Minuman, Jualan Runcit atau perkhidmatan profesional lain)",        
        label6: "Perniagaan saya adalah perniagaan pasif",
        p2: "Menjana 50% atau lebih hasil perniagaannya daripada pendapatan pasif (Contohnya Pelaburan, Sewa, Faedah, Dividen dan Royalti)",
        b1: "Simpan",
        b2: "Seterusnya",
        pleaseSelect: "Sila pilih",
        taxMinLenErr: "Sila masukkan sekurang-kurangnya 5 aksara."
    },
    AboutYourTransactionScreen: {
        h1: "Mengenai urus niaga anda",
        label1: "Apakah kegunaan utama akaun ini?",
        p1: "Sila jelaskan:",
        label2: "Sila berikan nama pelanggan semasa atau bakal pelanggan anda.",
        p2: "(1 nama setiap ruang sehingga 5 nama)",
        ck1: "Saya belum mempunyai nama tersebut",
        ph: "Masukkan nama",
        label3: "Tambah pelanggan",
        label4: "Sila berikan nama pembekal semasa atau bakal pembekal anda.",
        label5: "Tambah pembekal",
        label6: "Di manakah lokasi pelanggan dan pembekal anda? ",
        p3: "(sehingga 5 negara)",
        label7: "Tambah negara",
        label8: "Di manakah negara asal dan destinasi akhir barangan/perkhidmatan anda?",
        label9: "Adakah anda berurusan dengan mana-mana wilayah ini?",
        label10: "Berapakah bilangan transaksi yang anda jangkakan untuk setiap bulan?",
        label11: "Berapakah amaun transaksi yang anda jangkakan untuk setiap bulan?",
        infoBox: "Ini merujuk kepada negara mana pembekal anda memperoleh sumber dan pelanggan anda menjual. Cth. Pembekal anda di Thailand mungkin mendapatkan jed dari Myanmar untuk anda.",
        b1: "Simpan",
        b2: "Seterusnya",
        pleaseSelect: "Sila pilih",
        selectType:"Pilih jenis"
    },
    BusinessBankingServiceScreen : {
        h1: "Perkhidmatan Perbankan Perniagaan",
        label1: "Lokasi cawangan OCBC pilihan",
        label2: "Negeri",
        label3: "Cawangan",
        label4: "Perbankan Internet & Mudah Alih Perniagaan (OCBC Velocity)",
        p1: "1 orang memulakan dan meluluskan transaksi (Untuk pemilikan tunggal atau syarikat dengan pengarah tunggal)",
        p2: "2 orang memulakan dan meluluskan transaksi (Untuk perniagaan perkongsian & syarikat dengan 2 pengarah)",
        p3: "Pautan DuitNow ",
        ck1: "Pautkan BRN saya dengan Akaun OCBC eBiz ini",
        ck1_2: "Pautkan BRN saya dengan Akaun OCBC eBiz-i ini",
        ck1_3: "Link my BRN to this Business Access Account",
        ck1_4: "Link my BRN to this Business Signature Account",
        p4: "* Dengan memilih DuitNow, anda memberi kebenaran kepada Bank untuk mendaftarkan atau menukar ID DuitNow anda kepada OCBC selepas akaun dibuka.",
        p5: "OCBC OneCollect (Pungutan melalui QR)",
        ck2: "Saya ingin memohon OCBC OneCollect",
        p6_1: "* Untuk memahami lebih lanjut tentang OCBC OneCollect, sila layari",
        p6_2: "OCBC OneCollect.",
        p7: "* Sila ambil perhatian bahawa nombor telefon bimbit Malaysia diperlukan untuk pendaftaran OCBC OneCollect.",
        p8: {
            islamic: "Kad Debit-i Perniagaan",
            others: "Kad Debit Perniagaan"
        },
        p9: {
            part1: "Salah",
            part2: "Kedua-duanya",
            part3: "satu daripada maklumat yang diberi memerlukan perhatian anda.",
            part4: "Kami menerima sehingga 19 aksara bagi nama paparan di atas kad anda.",
        },
        card1: "Kad ",
        card2: "",
        p10: {
            islamic: "Ini akan tertera pada kad debit-i anda. Sila semak dengan teliti.",
            others: "Ini akan tertera pada kad debit anda. Sila semak dengan teliti."
        },
        link1: "Edit kad",
        p11: "Nama syarikat berdaftar",
        p12: {
            part1: "Nama untuk dipaparkan pada kad",
            part2: "(Mesti mengandungi nama yang tertera dalam dokumen pengenalan anda)",
        },
        p13: "Had Pengeluaran Harian ATM",
        p14: "Had Pembayaran Pembelian Harian ",
        ck3: "Pembelian Tanpa Sentuh ('Contactless') ",
        info1: "Ini merujuk kepada kaedah pembayaran yang selamat dan tanpa wayar bagi pengguna untuk membeli produk dan perkhidmatan menggunakan kad debit. Kad bercip ini membolehkan transaksi dibuat dengan menyentuh kad pada terminal tempat jualan (terminal POS) peniaga.",
        ck4: "Transaksi Dalam Talian",
        info2: "Transaksi dalam talian merujuk kepada kaedah pembayaran di mana wang dihantar melalui internet, melalui rangkaian elektronik.",
        b1: "Ok",
        link2: "Mansuhkan Kad",
        link3: "Tambah kad",
        p15: {
            islamic: "Jika mahu kami mengeluarkan kad debit-i perniagaan kepada individu lain, sila lawati mana-mana cawangan OCBC Bank.",
            others: "Jika perlu kami mengedarkan kad debit kepada individu lain, sila lawati mana-mana cawangan OCBC Bank."
        },        
        p16: {
            islamic: "Nota: Jika anda ialah pemegang Kad Debit Perniagaan-i OCBC (kad debit Islamik) yang sedia ada, tiada Kad Debit Perniagaan tambahan akan dikeluarkan berserta akaun perniagaan/-i semasa OCBC yang akan dibuka.",
            others: "Nota: Jika anda ialah pemegang Kad Debit Perniagaan OCBC (kad debit konvensional) yang sedia ada, tiada Kad Debit Perniagaan tambahan akan dikeluarkan berserta akaun perniagaan/-i semasa OCBC yang akan dibuka."
        },
        b2: "Simpan",
        b3: "Seterusnya",
        pleaseSelect: "Sila pilih"
    },
    SignatureScreen: {
        h1: "Tandatangan dan maklumat peribadi lain",
        label1: {
            part1: "Muat naik tandatangan",
            part2: "(JPEG, maksimum 5MB).",
            part3: "Tandatangan anda mungkin akan digunakan untuk mengesahkan cek anda."
        },
        dropbox: {
            p1: {
                part1: "Jenis fail yang disokong: JPG",
                part2: "Saiz fail maksimum: 5MB"
            },
            h4: "Tarik dan lepaskan fail di sini",
            p2: "----- atau -----",
            p3: "Pilih fail",
            b1: "Muat naik semula",
            b2: "Putar imej",
            error: "Sila pilih imej dengan format .jpg atau .jpeg" 
        },
        signpad: {
            p1: "Untuk memastikan rekod tandatangan yang tepat dengan bank, sila gunakan pen digital peranti anda.",
            b1: "Padam"
        },
        error1: "Sila tandatangan.",
        error2: "Sila muat naik tandatangan anda.",
        label2: "Nombor kad pengenalan lama (Pilihan)",
        info1: "Nombor kad pengenalan lama anda boleh didapati di belakang kad pengenalan baharu anda.",
        error3: "Nombor pengenalan lama diperlukan.",
        error4: "Invalid input. Please provide valid old identification number.",
        label3: "Sila nyatakan bangsa anda:",
        error5: "Sila pilih bangsa anda.",
        label4: "Adakah anda berstatus Bumi atau bukan Bumi?",
        error6: "Sila pilih sama ada anda bumi atau bukan bumi.",
        b1: "Muat naik",
        b2: "Tanda",
        pleaseSelect: "Sila pilih",
        nonBumi: "Bukan Bumi",
        b3: "Simpan",
        b4: "Seterusnya"     
    },
    CompanyConstitutuionScreen: {
        h1: "Perlembagaan Syarikat dan Ketetapan Lembaga (Board Resolution)",
        p1: "Sila baca maklumat berikut dengan teliti dan sahkan bahawa semuanya betul.",
        h4: "Perlembagaan Syarikat",
        p2: {
            part1: "Syarikat anda ",
            part2: "tidak",
            part3: "mempunyai Perlembagaan atau Perlembagaan Syarikat Anda",
            part4: "menggunakan format yang disediakan dalam jadual A di bawah Akta Syarikat 1965:"
        },
        ck1: "Betul",
        ck2: "Salah",
        p3: 'Anda juga boleh memilih "Betul" jika dokumen perlembagaan anda memenuhi perkara berikut:',
        p4: "Klausa kuorum untuk mesyuarat pengarah mestilah konsisten dengan bilangan sebenar pengarah yang dilantik.",
        p5: " Jika anda sebuah syarikat pengarah tunggal, pengarah mestilah boleh meluluskan ketetapan lembaga dengan merekodkannya dan menandatangani rekod tersebut.",
        h42: "Ketetapan Lembaga:",
        p6: {
            part1: "Ketetapan standard OCBC Bank",
            part2: "(Sendirian Berhad / Syarikat Awam)",
            part3: "telah diluluskan pada Mesyuarat Lembaga Pengarah yang diadakan pada",
            part4: "(di mana suatu kuorum hadir sepanjang mesyuarat).",
            part5: "Orang berikut dilantik untuk bertindak bagi pihak syarikat sebagai orang yang diberi kuasa dan penandatangan akaun-akaun yang akan dibuka."
        },
        p7: "Orang yang diberi kuasa boleh:",
        ul: {
            li1: "Membuka dan menutup akaun ",
            li2: "Memohon untuk perkhidmatan akaun dan perbankan, termasuk tapi tidak terhad kepada elektronik, pengurusan tunai, pembayaran dan pengiriman wang, serta perkhidmatan berkaitan perdagangan",
            li3: "Melantik pengguna yang diberi kuasa untuk perkhidmatan masing-masing",
            li4: "Melantik penandatangan yang dibenarkan",
            li5: "Meminjam dan memberikan sekuriti",
            li6: "Mengesahkan tandatangan spesimen",
            li7: "Memaklumkan tentang perubahan orang yang diberi kuasa",
            li8: "Berkomunikasi dan menandatangani secara elektronik"
        },
        p8: {
            part1: "Syarat tandatangan:",
            part2: "Tunggal",
            part3: "Kedua-dua pihak"
        },
        ck3: "Saya mengesahkan semua perkara di atas.",
        b1: "Seterusnya"
    },
    DeclarationScreen: {
        h1: "Maklumat mengenai pelanggan",
        p1: "Syarikat/Firma/Perniagaan mengizinkan, dan memberi jaminan dan pernyataan bahawa ia telah/akan mendapatkan keizinan Individu Yang Diberi Kuasa, Penandatangan Yang Diberi Kuasa, dan Pengguna yang Diberi Kuasa yang dilantik dari semasa ke semasa, untuk mendedahkan maklumat perhubungan mereka (tidak termasuk maklumat yang berkaitan dengan hal ehwal atau akaun Syarikat/Firma/Perniagaan) kepada Kumpulan OCBC* untuk pemasaran produk dan perkhidmatan yang diedarkan oleh Kumpulan OCBC*, yang mungkin Syarikat/Firma/Perniagaan sukai. Syarikat/Firma/Perniagaan boleh pada bila-bila masa menarik balik keizinan tersebut.",
        p1_2: "*Kumpulan OCBC bermaksud OCBC Bank (Malaysia) Berhad dan syarikat berkaitannya di Malaysia.",       
        ck1: "Ya",
        ck2: "Tidak",
        h1_2: "Pengakuan dan Persetujuan",
        p2: "Dengan mengklik di bawah, saya mengesahkan bahawa saya telah baca, faham dan terima perkara berikut:",
        p3: {
            part1: "Saya maklum bahawa terma-terma kontrak utama yang mempengaruhi kewajipan saya untuk semua perkhidmatan perbankan yang diterima melalui permohonan akaun semasa ini telah dijelaskan secukupnya kepada saya di dalam",
            part2: "Lembaran Pendedahan Produk",
            part3: "yang telah saya baca."
        },
        p4: "Saya faham bahawa saya mempunyai hak untuk bertanya dan berbincang dengan pegawai OCBC Bank jika saya tidak memahami terma dan syarat-syarat tersebut, dan saya telah pun melakukannya.",
        viewError: "Sila baca and fahami semua pautan",
        b1: "Setuju"
    },
    DirectorReviewScreen: {
        h1: "Semakan Akhir",
        yellowContent: "Anda boleh edit dengan mengklik ikon pen.",
        label1: "Akaun dipilih",
        h1_2: "Butiran Perniagaan",
        label2: "Nama perniagaan",
        label3: "Nombor pendaftaran",
        label4: "Perlembagaan",
        label5: "Alamat surat-menyurat",
        label6: "Nama",
        label7: "Alamat e-mel",
        label8: "Nombor telefon bimbit",
        h1_3: "Perkhidmatan Perbankan Perniagaan",
        h1_4: "Cawangan OCBC Pilihan:",
        li1: "Negeri",
        li2: "Cawangan",
        label9: "Perkhidmatan",
        li3: "Perbankan Internet & Mudah Alih Perniagaan (OCBC Velocity)",
        li4: "DuitNow",
        li5: "OCBC OneCollect (Pungutan melalui QR)",
        li6: {
            islamic: "Pemegang Kad Debit-i Perniagaan",
            others: "Pemegang Kad Debit Perniagaan",
        },
        h1_5: "Tandatangan",
        h1_6: "Permohonan ini akan disimpan dan boleh diperoleh semula daripada e-mel",
        b1: "Pembetulan diperlukan",
        b2: "Sah"
    },
    ThankYouApplication: {
        h1: "Satu langkah lagi",
        p1: "Untuk melengkapkan permohonan anda, anda perlu mengesahkan identiti anda dengan mengimbas kod QR di bawah yang akan membawa anda ke portal pengesahan eKYC yang dimiliki dan dibangunkan oleh CTOS. Ini akan mengambil masa kira-kira 5 minit.",
        p2: 'Untuk melengkapkan permohonan anda, anda perlu mengesahkan identiti anda dengan mengetik butang "Sahkan identiti" yang akan membawa anda ke portal pengesahan eKYC. Portal pengesahan eKYC ini dimiliki dan dibangunkan oleh CTOS. Process pengesahan identiti dijangka akan mengambil masa kira-kira 5 minit.',
        p3: "juga akan dapat e-mel untuk membuat pengesahan yang sama.",
        p4: "Nombor rujukan permohonan anda ialah",
        b1: "Sahkan identiti",
        p5: "Sebarang soalan?",
        p7: "Soalan-soalan lazim",
        p8: "Anda boleh menghubungi kami di:",
        p10: "atau",
        number: "603 8317 5200",
        p11: "Untuk melengkapkan permohonan anda, anda perlu mengesahkan identiti anda. E-mel yang mengandungi panduan untuk membuat sedemikian akan dihantar kepada anda dalam beberapa jam selepas ini."
    },
    LastStepScreen: {
        h1: "Semakan permohonan oleh pengarah lain ",
        label1: {
            part1: "Permohonan akan dihantar kepada pengarah anda yang lain untuk semakan. Sila masukkan butiran",
            part2: ""
        },
        label2: "Nombor telefon bimbit",
        label3: "E-mel anda",
        b1: "Hantar",
        numberError: {            
            required: "Sila masukkan nombor telefon bimbit anda",
            minlength1: "Sila masukkan sekurang-kurangnya ",
            minlength2: " aksara",
            pattern: "Sila masukkan format yang sah"
        },
        emailError: {
            required: "Sila masukkan alamat e-mel anda",
            pattern: "Sila masukkan alamat e-mel yang sah"
        },        
        noteTitle: "Nota",
        note2: "Nombor telefon bimbit dan alamat e-mel yang diberi akan digunakan oleh OCBC Bank untuk tujuan perhubungan / komunikasi berkaitan kesemua akaun syarikat / perniagaan / persendirian dengan OCBC Bank. Untuk mengemas kini / menukar maklumat perhubungan, sila kunjungi kami di mana-mana cawangan OCBC untuk bantuan."
    },
    EndLastStepScreen: {
        h1: "Semakan belum selesai ",
        p1: {
            part1: "Selepas",
            part2: "menyemak permohonan tersebut, anda berdua akan menerima e-mel untuk mengesahkan identiti anda."
        },
        p2: "Nombor Rujukan Permohonan anda ialah",
        p3: "Ada soalan?",
        p4: {
            part1: "Perubahan anda telah berjaya dihantar ke",
            part2: "untuk menyemak dan mengesahkan."
        },
        p5: "Soalan-soalan lazim",
        p6: "Anda boleh menghubungi kami di:",
        number: "603 8317 5200",
        p8: "atau"
    },
    CorrectionRequestScreen: {
        h1: "Permintaan pembetulan dihantar",
        p1: {
            part1: "Permohonan telah dihantar kepada",
            part2: "untuk pembetulan."
        },
        p2: "Nombor Rujukan Permohonan anda ialah",
        p3: "Ada soalan?",
        p4: "Anda boleh menghubungi kami di:",
        p5: "Soalan-soalan lazim",
        p6: "Anda boleh menghubungi kami di:",
        number: "603 8317 5200",
        p8: "atau"
    },
    ThankYouScreen: {
        h1_1: "Terima kasih atas permohonan anda!",
        p1: "Amat dikesali, anda tidak layak untuk membuka akaun perniagaan secara serta-merta dalam talian. Kami akan mengatur janji temu dengan anda.",
        h1_2: "Terima kasih kerana berminat",
        p2: "Dengan kesalnya, anda tidak layak untuk membuka akaun perniagaan-i dalam talian secara segera. Kami akan mengatur janji temu dengan anda.",
        h1_3: "Harap maaf, anda perlu mengemas kini rekod SSM anda terlebih dahulu.",
        p3: "Anda boleh mengemas kini rekod anda di",
        p4: {
            part1: "Hantarkan butiran hubungan anda",
            part2: "kepada kami untuk pengaturan temu janji.",
        }        
    },
    Footer: {
        s1: "Hak Cipta OCBC Bank (Malaysia) Berhad (199401009721 / 295400-W)",
        s2: "OCBC Al-Amin Bank Berhad (200801017151 / 818444-T). Hak cipta terpelihara.",
        copyRight: "Hak Cipta"
    }
}